export default __webpack_public_path__ + "static/media/music banner.dced7aed.jpg";